<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { SelectTriggerProps } from 'reka-ui';
  import { SelectIcon, SelectTrigger, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = withDefaults(
    defineProps<
      SelectTriggerProps & {
        class?: HTMLAttributes['class'];
        size?: 'sm' | 'default';
        hideIcon?: boolean;
      }
    >(),
    { size: 'default' },
  );

  const delegatedProps = reactiveOmit(props, 'class', 'size');
  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectTrigger
    data-slot="select-trigger"
    :data-size="size"
    v-bind="forwardedProps"
    :class="
      cn(
        'border data-[placeholder]:text-muted-foreground bg-background transition-all duration-200 [&_svg:not([class*=\'text-\'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-sm border bg-transparent px-3 text-xs whitespace-nowrap transition-[color,box-shadow] outline-none focus-visible:ring-[2px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
        props.class,
      )
    "
  >
    <slot />
    <SelectIcon v-if="!hideIcon" as-child>
      <i class="far fa-chevron-down opacity-50" />
    </SelectIcon>
  </SelectTrigger>
</template>
